export class RouteHelper {
  static Login = () => '/login';

  static App = () => '/';

  static ApplicationAccountsList = () => '/application-accounts';

  static AddApplicationAccount = () => '/application-accounts/form';

  static EditApplicationAccount = (id: number) => `/application-accounts/form/${id}`;

  static DriversList = () => '/drivers';

  static AddDriver = () => '/drivers/form';

  static EditDriver = (id: number) => `/drivers/form/${id}`;

  static VehiclesList = () => '/vehicles';

  static AddVehicle = () => '/vehicles/form';

  static EditVehicle = (id: number) => `/vehicles/form/${id}`;

  static SettlementsList = () => '/settlements';

  static AddSettlement = () => '/settlements/form';

  static EditSettlement = (id: number) => `/settlements/form/${id}`;

  static ExportSettlement = () => '/settlements/export';

  static ExportSettlementHistory = () => '/settlements/export-histories';

  static ImportSettlement = () => '/settlements/import';

  static OrganisationsList = () => '/organisations';

  static AddOrganisation = () => '/organisations/form';

  static EditOrganisation = (id: number) => `/organisations/form/${id}`;

  static UsersList = () => '/users';

  static AddUser = () => '/users/form';

  static EditUser = (id: string) => `/users/form/${id}`;

  static AuditList = () => '/audit';

  static Articles = (groupSlug: string) => `/articles/${groupSlug}`;

  static Article = (groupSlug: string, articleSlug: string) => `/articles/${groupSlug}/${articleSlug}`;

  static PaymentSettings = () => '/payment-settings';

  static SettlementSettings = () => '/settlement-settings';

  static Payoffs = () => '/payoffs';

  static ImportPayoffs = () => '/payoffs-import';

  static AddPayoff = () => '/payoffs/form';

  static EditPayoff = (id: number) => `/payoffs/form/${id}`;

  static Statistics = () => '/statistics';

  static StatisticsSettings = () => '/statistics-settings';

  static AiAssistantSettings = () => '/ai-assistant-settings';

  static Installments = () => '/installments';

  static AddInstallment = () => '/installments/form';

  static EditInstallment = (id: number) => `/installments/form/${id}`;

  static CashFlows = () => '/cash-flows';

  static AddCashFlow = () => '/cash-flows/form';

  static EditCashFlow = (id: number) => `/cash-flows/form/${id}`;

  static VehiclesLog = () => '/vehicles-log';

  static VehicleLogSettings = () => '/vehicle-log-settings';

  static ReportSettings = () => '/report-settings';

  static ReportsList = () => '/reports';

  static EditReport = (id: number) => `/reports/form/${id}`;

  static ResourceSettings = () => '/resource-settings';

  static Dashboard = () => '/dashboard';

  static CashFlowReports = () => '/cash-flow-reports';

  static Pit11 = () => '/pit-11';

  static DriverContactForms = () => '/driver-contact-forms';

  static SupportTickets = () => '/support-tickets';

  static SupportTicketDetails = (id: number) => `/support-tickets/${id}`;

  static Invoices = () => '/invoices';

  static DayOff = () => '/day-off';

  static Debtors = () => '/debtors';

  static DocumentSettings = () => '/document-settings';

  static VehiclesDocumentList = () => '/vehicles-document-list';

  static HrTagSettings = () => '/hr-tag-settings';

  static DigitalSignatures = () => '/digital-signatures';

  static BonusCampaigns = () => '/bonus-campaigns';

  static AddBonusCampaign = () => '/bonus-campaigns/form';

  static EditBonusCampaign = (id: number) => `/bonus-campaigns/form/${id}`;

  static InvitePrograms = () => '/invite-programs';

  static AddInviteProgram = (opts?: { copyFrom?: number }) => (opts?.copyFrom
    ? `/invite-programs/form?copyFrom=${opts.copyFrom}`
    : '/invite-programs/form');

  static EditInviteProgram = (id: number) => `/invite-programs/form/${id}`;

  static DigitalSignaturesToSign = () => '/digital-signatures-to-sign';

  static Mails = () => '/mails';

  static MailRules = () => '/mail-rules';

  static EditMailRules = (id: number) => `/mail-rules/form/${id}`;

  static DriverVerification = () => '/driver-verification';

  static OnlinePayments = () => '/online-payments';

  static Referrals = () => '/referrals';

  static AddReferral = () => '/referrals/form';

  static EditReferral = (id: number) => `/referrals/form/${id}`;

  static SmsCampaigns = () => '/sms-campaigns';

  static Exports = () => '/exports';

  static PenaltiesSummaryExport = () => '/exports/debtors-penalty-summary';

  static UserWithdrawSummaryExport = () => '/exports/withdraw-summary';

  static DriverVehicleReservations = () => '/driver-vehicle-reservations';
}
